import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const dismissVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type DismissProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof dismissVariants>;

const Dismiss = React.forwardRef<SVGSVGElement, DismissProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          dismissVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 20 20'}
        width={width}
        {...props}
      >
        <path d="M3.89701 4.05404L3.97001 3.97004C4.09699 3.84302 4.26535 3.76579 4.44446 3.75239C4.62357 3.739 4.80153 3.79032 4.94601 3.89704L5.03001 3.97004L10 8.93904L14.97 3.96904C15.0971 3.84217 15.2655 3.76512 15.4446 3.75191C15.6237 3.7387 15.8017 3.79019 15.946 3.89704L16.03 3.97004C16.157 4.09702 16.2343 4.26538 16.2476 4.44449C16.261 4.6236 16.2097 4.80157 16.103 4.94604L16.03 5.03004L11.061 10L16.031 14.97C16.1579 15.0971 16.2349 15.2656 16.2481 15.4447C16.2613 15.6238 16.2098 15.8017 16.103 15.946L16.03 16.03C15.903 16.1571 15.7347 16.2343 15.5556 16.2477C15.3764 16.2611 15.1985 16.2098 15.054 16.103L14.97 16.03L10 11.061L5.03001 16.031C4.90289 16.1579 4.73447 16.2349 4.55537 16.2482C4.37626 16.2614 4.19836 16.2099 4.054 16.103L3.97001 16.03C3.84299 15.903 3.76576 15.7347 3.75236 15.5556C3.73897 15.3765 3.79029 15.1985 3.89701 15.054L3.97001 14.97L8.93901 10L3.96901 5.03004C3.84214 4.90292 3.76509 4.7345 3.75188 4.5554C3.73867 4.37629 3.79016 4.19839 3.89701 4.05404Z" />
      </svg>
    );
  },
);

Dismiss.displayName = 'Dismiss';

export { Dismiss, dismissVariants };
